import {Dot, Icon, PopoverContent, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {DEFAULT_ROLE_DOT_COLOR_CLASS, ROLE_DOT_COLOR_CLASS} from '../config';

import type {RoleDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface TeamMemberRolePopoverContentProps {
  roles: RoleDTO[];
  selectedRoleKey: string;
  onSelect: (role: RoleDTO) => void;
}

/** Flat list of system roles — phase 1 has no custom roles, so there's no group header to render. */
export const TeamMemberRolePopoverContent: FC<TeamMemberRolePopoverContentProps> = ({
  roles,
  selectedRoleKey,
  onSelect
}) => {
  const {t} = useTranslation('common');

  return (
    <PopoverContent align="start" className="w-56 p-1">
      {roles.map(role => (
        <button
          key={role.id}
          type="button"
          onClick={() => onSelect(role)}
          className="flex w-full cursor-pointer items-center gap-2 rounded-sm p-2 hover:bg-background-surface_hover"
        >
          <Dot colorClassName={ROLE_DOT_COLOR_CLASS[role.key] ?? DEFAULT_ROLE_DOT_COLOR_CLASS} />
          <Typography size="sm" className="flex-1 text-start">
            {t(`roles.${role.key}`)}
          </Typography>
          {role.key === selectedRoleKey && (
            <Icon name="check" className="size-4 text-brand-primary" />
          )}
        </button>
      ))}
    </PopoverContent>
  );
};
